<template>
  <div>
    
    <div class="container-form">
      
        <el-row :gutter="10">
          
          <div style="text-align: center;" v-if="response.status == 'processamento'">           
            <div style="padding: 20px;">
              <img src="/public/img/loading-bar.gif" />
            </div>
            <div style="font-size: 14px;">
              aguarde...
            </div>
          </div>

          <div style="text-align: center;" v-if="response.status == 'sucesso' && response.inscricao.situacao_vaga">

            <h4 style="text-align: center;">INSCRIÇÃO REALIZADA COM SUCESSO!</h4>

            <img style="width: 80px; margin: 20px 0px;" src="/public/img/ok.png" />

            <p>A sua inscrição foi realizada com sucesso!</p>

            <div style="max-width: 700px; margin: 0 auto;">
                <p>
                    Atenção: Você deverá comparecer a instituição ao qual a criança foi pré-matriculado na
                    data {{ response.data }}, turno {{ response.turno }} para confirmação da matrícula.
                </p>
                <p>
                    Você pode imprimir ou baixar o comprovante de inscrição no botão a seguir.
                    O comprovante deverá ser apresentado na forma impressa ou digital (celular) no ato de confirmação da matrícula.
                </p>
            </div>

            <a style="margin: auto;" :href="`${$store.state.config.baseUrlApi}/comprovante-inscricao/${$route.params.cod}`" class="btn btn-primary">Comprovante de Inscrição</a>

          </div>

          <div style="text-align: center;" v-if="response.status == 'sucesso' && !response.inscricao.situacao_vaga">

            <h4 style="text-align: center;">SUA INSCRIÇÃO FOI INSERIDA NA LISTA DE ESPERA</h4>

            <img style="width: 150px; margin: 20px 0px;" src="/public/img/ampulheta.png" />

            <div style="max-width: 700px; margin: 0 auto;">
                <p>
                    Atenção: sua inscrição não está entre as vagas disponíveis. O inscrito foi
                    colocado na fila de espera e ficará aguardando a desistência de algum candidato que está entre as vagas disponíveis.
                </p>
            </div>

            <a style="margin: auto;" :href="`${$store.state.config.baseUrlApi}/comprovante-inscricao/${$route.params.cod}`" class="btn btn-primary">Comprovante de Inscrição</a>

          </div>

          <div style="text-align: center;" v-if="response.status == 'erro'">

            <h4 style="text-align: center;">NÃO FOI POSSÍVEL CONCLUIR!</h4>
            <img style="width: 80px; margin: 20px 0px;" src="/public/img/warning.png" />

            <div style="max-width: 700px; margin: 0 auto;">
                <p>
                  {{ response.message }}
                </p>
            </div>
            <div style="margin-top: 40px;">
                <a style="margin: auto;" href="/inscricao" class="btn btn-outline-dark">
                    <i class="fas fa-align-right"></i>
                    Tela de Inscrição
                </a>
            </div>

          </div>

        </el-row>       
      
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      qtdRequest: 0,
      response: {
        status: 'processamento',
        message: '',
        data: '',
        turno: '',
        inscricao: {}
      }
    };
  },
  mounted(){

    this.consultaInscricao();
  },
  methods: {

    consultaInscricao() {

      this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/pre-matricula/consultaStatusInscricaoNovatos/${this.$route.params.cod}`, this.$store.getters.getHeaderAuth).then(response => {
        
         
        if(response.data.status == 'processamento') {

          if(this.qtdRequest == 0) {

            setTimeout(() => {
              this.consultaInscricao();
              this.qtdRequest++;
            }, 3000);
            
          }else if(this.qtdRequest == 1) {
            
            setTimeout(() => {
              this.consultaInscricao();
              this.qtdRequest++;
            }, 5000);

          }else if(this.qtdRequest == 2) {
            
            setTimeout(() => {
              this.consultaInscricao();
              this.qtdRequest++;
            }, 15000);

          } else {

            setTimeout(() => {
              this.consultaInscricao();
            }, 30000);
          }          

        } else {

          this.response = response.data;          
        }

      }).catch((error) => { this.$store.commit('throwException', error); });

    }
  },
  components: {

  },
};
</script>